/**
 * Environment variable constants
 * 환경변수를 중앙에서 관리하기 위한 상수 모음
 */

export const ENV = {
  NODE_ENV: process.env.NODE_ENV,
  NEXT_PUBLIC_API_URL: process.env.NEXT_PUBLIC_API_URL,
  NEXT_PUBLIC_GA_ID: process.env.NEXT_PUBLIC_GA_ID,
} as const;

export const IS_PRODUCTION = ENV.NODE_ENV === 'production';
export const IS_DEVELOPMENT = ENV.NODE_ENV === 'development';
export const IS_TEST = ENV.NODE_ENV === 'test';
